import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

type ErrorSelector = (state: ReduxState) => string | undefined

const getErrorSelector = (state: ReduxState) => state.productAttributes.UIState.error

export const errorSelector: ErrorSelector = createSelector(getErrorSelector, error => error)
